import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { getCleanedUrlParams, showError } from '@utils';
import { FILTER_RULE_ENUMS, LIMIT } from '@constants';
import { QUERY_KEYS } from 'constants/queryKeys';
import { usersServices } from '@services';
import { handleUsers } from './utils';

export const USERS_PAGE_SIZE = LIMIT;

export const useUsersOperations = () => {
  const router = useRouter();
  const page = router.query?.page || 1;
  const pageSize = router.query?.pageSize || USERS_PAGE_SIZE;
  const orderBy = router.query?.orderBy || '';
  const order = router.query?.order || '';
  const query = router.query?.query || '';
  const EMPTY_RULE = {
    type: FILTER_RULE_ENUMS.EmptyRuleType,
  };
  const usersResponse = useQuery(
    [QUERY_KEYS.GET_USERS_KEY, { page, pageSize, orderBy, order, query }],
    () =>
      usersServices?.filterUsers({
        params: getCleanedUrlParams({
          page,
          pageSize: parseInt(pageSize, 10) || USERS_PAGE_SIZE,
          orderBy,
          order,
          query,
        }),
        payload: EMPTY_RULE,
      }),
    { enabled: router.isReady }
  );

  const enumsResponse = useQuery(
    [QUERY_KEYS.GET_USERS_ENUMS_KEY],
    () => usersServices.getUsersEnums(),
    { enabled: router.isReady }
  );
  const users = handleUsers(usersResponse?.data?.data || []);

  useEffect(() => {
    if (usersResponse?.error) {
      showError(usersResponse?.error);
    }
  }, [usersResponse?.error]);

  return {
    page,
    total: usersResponse?.data?.meta?.total,
    loading: usersResponse?.isLoading,
    users,
    pageSize: parseInt(pageSize, 10) || USERS_PAGE_SIZE,
    enums: enumsResponse?.data?.data || {},
    getUsers: usersResponse.refetch,
  };
};
